module.exports = __webpack_public_path__ + "static-portal/img/hy.3f5d6f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy.jpg
// module id = d5E0
// module chunks = 4